/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Wrong_AnswerInputs */

const en_faq_wrong_answer = /** @type {(inputs: Faq_Wrong_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We test it against real scenarios, define what needs human review and make runs traceable. Missing information and unusual requests need a clear handoff to a person.`)
};

const lv_faq_wrong_answer = /** @type {(inputs: Faq_Wrong_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs to pārbaudām reālos scenārijos, nosakām, kam nepieciešama cilvēka pārbaude, un padarām izpildes izsekojamas. Trūkstoša informācija un neierasti pieprasījumi tiek skaidri nodoti cilvēkam.`)
};

/**
* | output |
* | --- |
* | "We test it against real scenarios, define what needs human review and make runs traceable. Missing information and unusual requests need a clear handoff to a..." |
*
* @param {Faq_Wrong_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_wrong_answer = /** @type {((inputs?: Faq_Wrong_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Wrong_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_wrong_answer(inputs)
	return en_faq_wrong_answer(inputs)
});